import { STRINGS } from '../i18n/strings';

const specialCharactersRegex = /[!@#$%^&*()²~£μ§€_+\-=[\]{};':"\\|,.<>/?]/;
const errorMessage = STRINGS.FR.FORM_ERROR_INVALID_CHARACTER;

export const noSpecialCharacters = (value: string) => {
  return !specialCharactersRegex.test(value) || errorMessage;
};

export const noSpecialCharactersNorNumbersFilter = (value: string) => {
  return (
    (!specialCharactersRegex.test(value) && !/\d+$/g.test(value)) ||
    errorMessage
  );
};

type DateValue = string | Date;
export const dateValidator = {
  validate: {
    hasAllValues: (v: DateValue) => {
      if (v instanceof Date) {
        return true;
      }
      const values = v ? v.split('/') : [];

      if (values.length === 0 || v === '//') {
        return true;
      }

      return (
        values.filter(Boolean).length === 3 ||
        "La date n'est pas encore complète, elle doit comporter le jour, le mois et l’année"
      );
    },
    dayValid: (v: DateValue) => {
      if (v instanceof Date) {
        return true;
      }
      const values = v ? v.split('/') : [];

      if (values.length === 0 || v === '//') {
        return true;
      }

      return (
        (values[0] && parseInt(values[0]) <= 31) ||
        'Le jour ne peut pas être supérieur à 31'
      );
    },
    monthValid: (v: DateValue) => {
      if (v instanceof Date) {
        return true;
      }
      const values = v ? v.split('/') : [];

      if (values.length === 0 || v === '//') {
        return true;
      }

      return (
        (values[1] && parseInt(values[1]) <= 12) ||
        'Le mois ne peut pas être supérieur à 12'
      );
    },
    isNaN: (v: DateValue) => {
      if (v instanceof Date) {
        return true;
      }
      const values = v ? v.split('/') : [];

      if (values.length === 0 || v === '//') {
        return true;
      }

      return (
        values
          .filter(Boolean)
          .every((item: DateValue) => !isNaN(parseInt(item as string))) ||
        'La date n’est pas valide'
      );
    },
    hasLeadingZero: (v: DateValue) => {
      if (v instanceof Date) {
        return true;
      }
      const values = v ? v.split('/') : [];

      if (values.length === 0 || v === '//') {
        return true;
      }

      const parsedDay = parseInt(values[0]);
      const parsedMonth = parseInt(values[1]);
      let isDayValid = true;
      let isMonthValid = true;
      if (parsedDay < 10 && values[0].substring(0, 1) !== '0') {
        isDayValid = false;
      }
      if (parsedMonth < 10 && values[1].substring(0, 1) !== '0') {
        isMonthValid = false;
      }
      return (
        (isDayValid && isMonthValid) ||
        'Les jours et mois doivent commencer par un 0 si inférieurs à 10'
      );
    }
  }
};
